import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _77d3f4c9 = () => interopDefault(import('../src/pages/baggage-details/index.vue' /* webpackChunkName: "pages/baggage-details/index" */))
const _5e9ecd5a = () => interopDefault(import('../src/pages/booking-products/index.vue' /* webpackChunkName: "pages/booking-products/index" */))
const _5e87cc84 = () => interopDefault(import('../src/pages/callback.vue' /* webpackChunkName: "pages/callback" */))
const _e15c0f82 = () => interopDefault(import('../src/pages/downloads/index.vue' /* webpackChunkName: "pages/downloads/index" */))
const _4d724cd2 = () => interopDefault(import('../src/pages/guests-details/index.vue' /* webpackChunkName: "pages/guests-details/index" */))
const _24f02a8c = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _15067aa4 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _d921391a = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _107d7387 = () => interopDefault(import('../src/pages/my-profile.vue' /* webpackChunkName: "pages/my-profile" */))
const _4854669a = () => interopDefault(import('../src/pages/search-booking.vue' /* webpackChunkName: "pages/search-booking" */))
const _59cfd316 = () => interopDefault(import('../src/pages/downloads/error.vue' /* webpackChunkName: "pages/downloads/error" */))
const _a4dec722 = () => interopDefault(import('../src/pages/downloads/ticket.vue' /* webpackChunkName: "pages/downloads/ticket" */))
const _69ca7923 = () => interopDefault(import('../src/pages/guests-details/questionnaire.vue' /* webpackChunkName: "pages/guests-details/questionnaire" */))
const _29cbf7ec = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _0c3af1ed = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _4ec4c5d2 = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _23e047a3 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/baggage-details",
    component: _77d3f4c9,
    name: "baggage-details"
  }, {
    path: "/booking-products",
    component: _5e9ecd5a,
    name: "booking-products"
  }, {
    path: "/callback",
    component: _5e87cc84,
    name: "callback"
  }, {
    path: "/downloads",
    component: _e15c0f82,
    name: "downloads"
  }, {
    path: "/guests-details",
    component: _4d724cd2,
    name: "guests-details"
  }, {
    path: "/login",
    component: _24f02a8c,
    name: "login"
  }, {
    path: "/maintenance",
    component: _15067aa4,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _d921391a,
    name: "manage-booking"
  }, {
    path: "/my-profile",
    component: _107d7387,
    name: "my-profile"
  }, {
    path: "/search-booking",
    component: _4854669a,
    name: "search-booking"
  }, {
    path: "/downloads/error",
    component: _59cfd316,
    name: "downloads-error"
  }, {
    path: "/downloads/ticket",
    component: _a4dec722,
    name: "downloads-ticket"
  }, {
    path: "/guests-details/questionnaire",
    component: _69ca7923,
    name: "guests-details-questionnaire"
  }, {
    path: "/manage-booking/cancel",
    component: _29cbf7ec,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/update-details",
    component: _0c3af1ed,
    name: "manage-booking-update-details"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _4ec4c5d2,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _23e047a3,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
